export const USER = 'USER'
export const NAV = 'NAV'
export const CARTNUM = 'CARTNUM'
